import React, { useState, useEffect } from "react";
import Header from "../Header";

import { store } from "../../Redux/store";
import StakeCards from "./StakeCards";
import Footer from "../Footer";

export default function (props) {
  return (
    <>
      <div className="bgimg">
        <Header Connect={props.Connect} setConnect={props.setConnect} />
        <StakeCards Connect={props.Connect} setConnect={props.setConnect} />
        {/* <Footer /> */}
      </div>
    </>
  );
}
